import { styled } from '@mui/system';

export const Wrapper = styled('div')`
    margin-top: 10px;
    margin-bottom: 10px;
`;